

















































import { Component, Vue } from 'vue-property-decorator';

// request
import MyOrdersWidget from '@/components/home/requester/MyOrdersWidget.vue';

// core
import SystemNoteWidget from '@/components/home/SystemNoteWidget.vue';
import { mapGetters } from 'vuex';

@Component({
  components: {
    SystemNoteWidget,
    MyOrdersWidget
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId'
  })
})
export default class HomeComponent extends Vue {
  currentPropertyId!: string;
}
